import type { PostFields } from '@tribeplatform/gql-client/graphql/post'
import type {
  PaginatedPost,
  QueryDraftPostsArgs,
} from '@tribeplatform/gql-client/types'

import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '../../lib/react-query/useInfiniteQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getDraftPostsKey } from '../../utils/keys/post.key.js'

export const useDraftPosts = (options: {
  variables: QueryDraftPostsArgs
  fields?: PostFields
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<PaginatedPost>
}) => {
  const {
    variables,
    fields = 'default',
    useInfiniteQueryOptions,
  } = options || {}
  const { client } = useTribeClient()
  const postsKey = getDraftPostsKey({
    variables: { ...variables },
  })

  return useInfiniteQuery<PaginatedPost>(
    postsKey,
    ({ pageParam: after }) =>
      client?.posts.draftPosts({ after, ...variables }, fields),
    useInfiniteQueryOptions,
  )
}
